import { render } from "./CodeView.vue?vue&type=template&id=084466a3&scoped=true"
import script from "./CodeView.vue?vue&type=script&lang=js"
export * from "./CodeView.vue?vue&type=script&lang=js"

import "./CodeView.vue?vue&type=style&index=0&id=084466a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084466a3"]])

export default __exports__